if (!customElements.get("quick-add")) {
  customElements.define(
    "quick-add",
    class QuickAdd extends HTMLElement {
      getFocusableElements(parent) {
        const focusableElementsSelector =
          "button:not(.wt-product__sticky-buy__button), [href], input:not(.disabled):not([type='hidden']), select, .close-btn";
        const focusableElements = () =>
          Array.from(parent.querySelectorAll(focusableElementsSelector)).filter(
            (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
          );

        return {
          focusableElements,
          first: focusableElements()[0],
          last: focusableElements()[focusableElements().length - 1],
        };
      }

      connectedCallback() {
        this.add_button = this.querySelector("button");
        this.isDrawerOpen = false;
        this.isMobile = window.innerWidth < 768;
          if (this.add_button)
            this.add_button.addEventListener("click", (e) => {
          const button = e.currentTarget;
          const cardLink = button
          .closest(".card__picture-container")
          ?.querySelector("a.card");
          this.product_url = this.add_button.getAttribute("data-product-url");
            this.currentTrigger = cardLink;
            this.fetchProduct(this.product_url);
          });

        this.handleInteractionOutside =
          this.handleInteractionOutside.bind(this);

        this.getFocusableElements = this.getFocusableElements.bind(this);

        this.lastFeaturedImage;
        this.firstMedia;
        this.hasFirstMediaImg;

        this.fetchProduct = this.fetchProduct.bind(this);
        this.galleryObserver = this.galleryObserver.bind(this);
        this.observerCallback = this.observerCallback.bind(this);
        this.disconnectObserver = this.disconnectObserver.bind(this);
        this.removeButtonEventListener =
          this.removeButtonEventListener.bind(this);
      }

      fetchProduct(product_url) {
        this.lastFeaturedImage = null;
        this.firstMedia = null;
        this.hasFirstMediaImg = null;
        this.quick_add = document.querySelector(".wt__quick-buy");
        this.quick_add_container = document.querySelector(
          ".wt__quick-buy__container",
        );
        this.quick_add_wrapper = document.querySelector(
          ".wt__quick-buy--wrapper",
        );
        this.quick_add_product = this.quick_add.querySelector(
          ".wt__quick-buy--product",
        );
        this.close_button = this.quick_add.querySelector(".close-btn");
        this.loader = this.quick_add.querySelector(".wt__quick-buy-loader");
        this.page_overlay = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        this.body = document.body;

        const controller = new AbortController();
        const signal = controller.signal;

        const allWtProducts =
          this.quick_add_wrapper.querySelectorAll(".wt-product");
        allWtProducts?.forEach((product) => product.remove());
        this.quick_add.classList.remove("hidden");
        this.body.classList.add("quick-buy-page-overlay");
        this.page_overlay.classList.add("wt__quick-buy--page-overlay--open");

        this.interactiveEelements = () =>
          this.quick_add_container.querySelectorAll();

        this.quick_add_container.classList.add(
          "wt__quick-buy__container--open",
        );

        this.close_button.addEventListener("click", () => {
          controller.abort();
          this.closeCart();
          this.close_button.setAttribute("tabindex", "-1");
          this.currentTrigger?.focus();
        });

        this.quick_add_container.addEventListener("keydown", (e) => {
          const isTabPressed =
            e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
          const { first, last } = this.getFocusableElements(
            this.quick_add_container,
          );

          if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
            this.close_button.click();
          }

          if (isTabPressed) {
            if (e.shiftKey && document.activeElement === first) {
              last.focus();
              e.preventDefault();
            } else if (!e.shiftKey && document.activeElement === last) {
              first.focus();
              e.preventDefault();
            }
          }
        });

        fetch(product_url, { signal })
          .then((res) => res.text())
          .then((res) => {
            this.loader.classList.add("hidden");
            const htmlDocument = new DOMParser().parseFromString(
              res,
              "text/html",
            );
            this.productMain = htmlDocument.querySelector(".wt-product__main");
            this.productCard = htmlDocument.querySelector(".wt-product");
            this.productInfo = htmlDocument.querySelector(".wt-product__info");

            const animatedElements = this.productMain.querySelectorAll(
              ".scroll-trigger.animate--slide-in",
            );
            animatedElements?.forEach((element) =>
              element.classList.remove("scroll-trigger", "animate--slide-in"),
            );

            const productGallery =
            this.productCard.querySelector("gallery-section");


            this.removeElements(
              this.productCard,
              "collapsible-section",
              "[not-quick-add]",
              ".product__inventory",
              ".share-icons__container",
              "#gallery-loader",
              "pickup-availability",
              ".wt-product__sku",
              ".wt-product__feature-icons",
              "gallery-section",
            );

            const newVariantId =
              this.productCard.querySelector("variant-options");
            if (newVariantId) {
              newVariantId.dataset.updateUrl = "false";
              this.updateAttribute(
                newVariantId,
                "data-original-section",
                newVariantId.getAttribute("data-section"),
              );
              this.updateAttribute(
                newVariantId,
                "data-section",
                `quick-${newVariantId.getAttribute("data-section")}`,
              );
            }

            productGallery.style.display = "none";

            this.images = productGallery.querySelectorAll("img");
            this.updateAttribute(
              productGallery,
              "id",
              `MediaGallery-${newVariantId?.getAttribute("data-section")}`,
            );
            const firstImageFromGallery = productGallery.querySelector("li");
            if (firstImageFromGallery) {
              this.firstMedia = firstImageFromGallery;

              this.playBtn = this.firstMedia.querySelector(".model-btn");
              if (this.playBtn) this.playBtn.setAttribute("tabindex", "0");

              this.video = this.firstMedia.querySelector("video");
              if (this.video) this.video.setAttribute("tabindex", "0");

              this.hasFirstMediaImg = Boolean(
                firstImageFromGallery.querySelector("img"),
              );
            }

            firstImageFromGallery
              ?.querySelector("img")
              ?.removeAttribute("srcset");
            const imageContainer = document.createElement("div");
            imageContainer.setAttribute("class", "product-image");

            const productDetails = document.createElement("div");
            productDetails.setAttribute("class", "wt-product__details");

            const productAbout = document.createElement("div");
            productAbout.setAttribute("class", "product-info");
            const title = this.productInfo.querySelector(".wt-product__name");

            if (title) {
              const aElement = document.createElement("a");
              aElement.textContent = title.textContent;
              aElement.href = this.product_url;
              title.innerHTML = "";
              title.appendChild(aElement);
              title.setAttribute("tabindex", "0");
            }

            const productElementsToCopy = this.productInfo.querySelectorAll(
              ".wt-product__brand, .wt-product__name, .wt-rating, .wt-product__price, .product__tax",
            );

            productElementsToCopy.forEach((product) =>
              productAbout.appendChild(product),
            );

            imageContainer.innerHTML = firstImageFromGallery?.innerHTML || "";
            productDetails.appendChild(imageContainer);
            productDetails.appendChild(productAbout);
            this.productInfo.prepend(productDetails);

            this.galleryObserver();

            const mainProductPrice =
              this.productCard.querySelector(".wt-product__price");
            this.updateAttribute(
              mainProductPrice,
              "id",
              `price-${newVariantId?.getAttribute("data-section")}`,
            );

            const allFieldSets = this.productCard.querySelectorAll("fieldset");
            this.updateFieldSets(allFieldSets);

            const addBtn = this.productCard.querySelector('button[name="add"]');
            this.updateAttribute(
              addBtn,
              "id",
              `ProductSubmitButton-${newVariantId?.getAttribute("data-section")}`,
            );

            const form = this.productCard.querySelector(
              'form[method="post"][data-type="add-to-cart-form"]',
            );
            this.updateAttribute(
              form,
              "id",
              `product-form-${newVariantId?.getAttribute("data-section")}`,
            );

            const viewAllDetailsContainer =
              this.quick_add_wrapper.querySelector(
                ".wt__quick-buy__view-all-container",
              );
            this.quick_add_wrapper.removeChild(viewAllDetailsContainer);
            this.quick_add_wrapper.innerHTML += this.productCard.outerHTML;
            this.quick_add_wrapper.append(viewAllDetailsContainer);

            const giftCardInput = this.quick_add_wrapper.querySelector(
              '[name="properties[__shopify_send_gift_card_to_recipient]"]',
            );
            if (giftCardInput) giftCardInput.removeAttribute("disabled");

            this.addViewAllDetailsButton();
            this.isDrawerOpen = true;

            // ---- VARIANT CARD LABEL FIX ----
            // After HTML is injected, sync checked state so CSS :checked works
            // and add click listeners for variant-card-label style radio cards
            setTimeout(() => {
              this.syncVariantCardCheckedState();
              this.attachVariantCardClickListeners();
            }, 50);
            // ---- END VARIANT CARD LABEL FIX ----

            // Fire the quick-buy drawer-open event
            publish(PUB_SUB_EVENTS.quickBuyDrawerOpen, { source: "quick-add" });

            this.close_button.setAttribute("tabindex", "0");
            this.close_button.focus();

            document.addEventListener("click", this.handleInteractionOutside);
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.error("Fetch aborted");
            } else {
              console.error("Fetch error:", error);
            }
          });
      }

      // ---- NEW METHOD: Sync checked state for variant card labels ----
      syncVariantCardCheckedState() {
        const quickAdd = document.querySelector(".wt__quick-buy");
        if (!quickAdd) return;

        const fieldsets = quickAdd.querySelectorAll("fieldset");
        fieldsets.forEach((fieldset) => {
          const radios = fieldset.querySelectorAll('input[type="radio"]');
          let anyChecked = Array.from(radios).some((r) => r.checked);

          // If none checked, check the first one as default
          if (!anyChecked && radios[0]) {
            radios[0].checked = true;
          }

          // Now update all labels visual state
          radios.forEach((radio) => {
            const label = quickAdd.querySelector(
              `label[for="${radio.getAttribute("id")}"]`
            );
            if (!label || !label.classList.contains("variant-card-label"))
              return;

            if (radio.checked) {
              label.classList.add("variant-card-label--qa-checked");
            } else {
              label.classList.remove("variant-card-label--qa-checked");
            }
          });
        });

        // Inject quick-view specific CSS for variant-card-label if not already added
        if (!document.getElementById("qa-variant-card-css")) {
          const style = document.createElement("style");
          style.id = "qa-variant-card-css";
          style.innerHTML = `
           /* Quick view variant card layout */
.wt__quick-buy .f-button__list:has(.metafield-rich_text_field) {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 10px !important;
  white-space: nowrap !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.wt__quick-buy .f-button__list::-webkit-scrollbar {
  display: none;
  width: 0 !important;
}

.wt__quick-buy .f-button__list__item {
  width: 100% !important;
}

.wt__quick-buy .variant-card-label {
  display: block !important;
  width: 100% !important;
  padding: 14px 16px !important;
  border: 1.5px solid #e0e0e0 !important;
  border-radius: 12px !important;
  cursor: pointer !important;
  transition: border-color 0.2s !important;
  height: auto !important;
}

/* Selected State */
.wt__quick-buy .variant-card-label--qa-checked {
  border-color: #E7AC39 !important;
  background: #E7AC390D !important;
  padding: 10px 16px !important;
  border-radius: 10px !important;
}

.wt__quick-buy .variant-card-radio__selected {
  display: none !important;
}

.wt__quick-buy .variant-card-radio__unselected {
  display: block !important;
}

.wt__quick-buy .variant-card-label--qa-checked .variant-card-radio__selected {
  display: block !important;
}

.wt__quick-buy .variant-card-label--qa-checked .variant-card-radio__unselected {
  display: none !important;
}

.wt__quick-buy .variant-card-header {
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
  gap: 5px !important;
  flex-wrap: wrap !important;
  row-gap: 10px !important;
}

.wt__quick-buy .variant-card-title {
  flex: 1 !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  line-height: 21px !important;
  letter-spacing: 2% !important;
  text-transform: capitalize !important;
  text-align: left !important;
  color: #434343 !important;
}

.wt__quick-buy .variant-card-price__current {
  font-weight: 600 !important;
  color: #434343 !important;
  font-size: 20px !important;
  line-height: 14px !important;
  letter-spacing: 2% !important;
  text-align: right !important;
  text-transform: capitalize !important;
}

.wt__quick-buy .variant-card-price__compare {
  text-decoration: line-through !important;
  opacity: 0.5 !important;
  font-size: 0.85em !important;
  margin-left: 4px !important;
}

.wt__quick-buy .variant-card-description {
  font-size: 12px !important;
  color: #434343 !important;
  margin-top: 8px !important;
  border-top: 1px solid #E8E8E8 !important;
  text-align: left !important;
}

.wt__quick-buy .variant-card-description ul {
  margin-top: 8px !important;
  padding-left: 13px !important;
}

.wt__quick-buy .variant-card-description li {
  color: #434343 !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  margin: 0 !important;
}

.wt__quick-buy .variant-card-label:hover:not(.variant-card-label--qa-checked) {
  background: rgb(231 172 57 / 0.05) !important;
  border-color: rgb(231 172 57 / 0.36) !important;
}
.wt__quick-buy .proven-packs__grid {
    all: unset;
    display: grid;
    grid-template-columns: repeat(3, 130px);
    gap: 10px;
}
 .wt__quick-buy   .proven-pack:has(.proven-pack__input:checked) {
    position: relative;
    border: 1px solid  #E7AC39;
    border-radius: 10px;
    background: #E7AC390D !important;
}
  .wt__quick-buy  .proven-pack:hover {
    border-color: #E7AC39;
}
     .wt__quick-buy span.proven-pack__text{
     font-size:12px;
     line-height:1.2;
     }
  .wt__quick-buy  .proven-pack__input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
}
  .wt__quick-buy  .proven-pack__media {
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
    padding-inline: 15px;
}
  .wt__quick-buy  .proven-pack__media img {
    width: auto;
    max-height: 64px;
    object-fit: contain;
}
   .wt__quick-buy  .proven-pack:has(.proven-pack__input:checked) {
    position: relative;
    border: 1px solid  #E7AC39;
    border-radius: 10px;
    background: #E7AC390D !important;
}
  .wt__quick-buy  .proven-pack {
    display: flex;
    flex-direction: column;
    padding: 10px 0 10px;
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    background: #BDBDBD0D;
    cursor: pointer;
    overflow: hidden;
    transition: border-color 0.15s ease;
    text-align:center;
    gap:5px !important;
}

/* Mobile */
@media screen and (max-width: 767px) {
  .wt__quick-buy .f-button__list:has(.metafield-rich_text_field) {
    grid-template-columns: repeat(2, minmax(300px, 1fr)) !important;
    gap: 10px !important;
  }

  .wt__quick-buy span.variant-card-price {
    margin-left: 10px !important;
  }

  .wt__quick-buy .variant-card-label--qa-checked {
    padding: 16px 10px !important;
  }

  .wt__quick-buy .variant-card-title {
    flex: 1 !important;
  }

  .wt__quick-buy .variant-card-header {
    flex-wrap: wrap !important;
  }

  .wt__quick-buy .variant-card-price {
    flex: 0 0 100% !important;
    text-align: left !important;
    justify-content: flex-start !important;
  }

  .wt__quick-buy .variant-card-description ul {
    margin-top: 10px !important;
  }
}
          `;
          document.head.appendChild(style);
        }
      }

      // ---- NEW METHOD: Click listener for variant-card-label in quick view ----
      attachVariantCardClickListeners() {
        const quickAdd = document.querySelector(".wt__quick-buy");
        if (!quickAdd) return;

        const variantCardLabels = quickAdd.querySelectorAll(".variant-card-label");
        variantCardLabels.forEach((label) => {
          label.addEventListener("click", () => {
            const forAttr = label.getAttribute("for");
            if (!forAttr) return;

            const radio = quickAdd.querySelector(`#${CSS.escape(forAttr)}`);
            if (!radio) return;

            // Get all radios in same fieldset
            const fieldset = radio.closest("fieldset");
            if (!fieldset) return;

            const siblingsRadios = fieldset.querySelectorAll('input[type="radio"]');
            siblingsRadios.forEach((r) => {
              r.checked = false;
              const sibLabel = quickAdd.querySelector(
                `label[for="${r.getAttribute("id")}"]`
              );
              if (sibLabel && sibLabel.classList.contains("variant-card-label")) {
                sibLabel.classList.remove("variant-card-label--qa-checked");
                // Reset radio icons
                const selected = sibLabel.querySelector(".variant-card-radio__selected");
                const unselected = sibLabel.querySelector(".variant-card-radio__unselected");
                if (selected) selected.style.display = "none";
                if (unselected) unselected.style.display = "block";
              }
            });

            // Check clicked radio
            radio.checked = true;
            label.classList.add("variant-card-label--qa-checked");
            const selected = label.querySelector(".variant-card-radio__selected");
            const unselected = label.querySelector(".variant-card-radio__unselected");
            if (selected) selected.style.display = "block";
            if (unselected) unselected.style.display = "none";

            // Trigger change event so variant-options JS picks it up
            radio.dispatchEvent(new Event("change", { bubbles: true }));
          });
        });
      }
      // ---- END NEW METHODS ----

      addViewAllDetailsButton() {
        const viewAllDetailsContainer = this.quick_add_wrapper.querySelector(
          ".wt__quick-buy__view-all-container",
        );
        const link = viewAllDetailsContainer.querySelector("a");
        link.href = this.product_url;
        link.setAttribute("tabindex", "0");
        viewAllDetailsContainer.classList.remove("hidden");
      }

      hideViewAllDetailsButton() {
        const viewAllDetailsContainer = this.quick_add_wrapper.querySelector(
          ".wt__quick-buy__view-all-container",
        );
        viewAllDetailsContainer.classList.add("hidden");
      }

      galleryObserver() {
        const config = {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
        };
        this.observer = new MutationObserver(this.observerCallback);
        this.observer.observe(this.quick_add_wrapper, config);
      }

      observerCallback(mutations) {
        for (const mutation of mutations) {
          if (mutation.target.localName === "variant-options") {
            this.quick_add = document.querySelector(".wt__quick-buy");
            const variantOptions =
              this.quick_add.querySelector("variant-options");
            const imageContainer =
              this.quick_add.querySelector(".product-image");
            const image = imageContainer.querySelector("img");
            const formInput = this.quick_add.querySelector(
              'form input[name="id"]',
            );
            if (variantOptions.getAttribute("data-variant-id")) {
              formInput.value = variantOptions.getAttribute("data-variant-id");
              formInput.setAttribute(
                "value",
                variantOptions.getAttribute("data-variant-id"),
              );
            }
            if (
              variantOptions.getAttribute("data-featured-image") &&
              this.lastFeaturedImage !==
                variantOptions.getAttribute("data-featured-image")
            ) {
              image?.setAttribute(
                "src",
                variantOptions.getAttribute("data-featured-image"),
              );
              image?.removeAttribute("srcset");

              this.lastFeaturedImage = variantOptions.getAttribute(
                "data-featured-image",
              );
              if (
                imageContainer.children[0]?.nodeName !== "IMG" &&
                imageContainer.children[0]?.nodeName !== "A"
              ) {
                const newImage = document.createElement("img");
                newImage.setAttribute(
                  "class",
                  "wt-product__img  wt-product__img--zoom-cursor",
                );
                newImage.setAttribute(
                  "src",
                  variantOptions.getAttribute("data-featured-image"),
                );
                newImage.removeAttribute("srcset");
                imageContainer.innerHTML = "";
                imageContainer.appendChild(newImage);
              } else {
                image.setAttribute(
                  "src",
                  variantOptions.getAttribute("data-featured-image"),
                );
                image.removeAttribute("srcset");
              }
              this.lastFeaturedImage = variantOptions.getAttribute(
                "data-featured-image",
              );
            } else {
              const hasFirstMediaModel =
                this.firstMedia?.querySelector("model-element");
              if (!this.hasFirstMediaImg || hasFirstMediaModel)
                imageContainer.innerHTML = this.firstMedia?.innerHTML;
            }

            // ---- SYNC CHECKED STATE ON VARIANT CHANGE ----
            // When variant-options fires (user clicks a radio),
            // re-sync all variant-card-label checked classes
            setTimeout(() => {
              this.syncVariantCardCheckedState();
            }, 10);
            // ---- END SYNC ----

            break;
          }
        }
      }

      handleInteractionOutside(event) {
        if (this.isDrawerOpen && event.target === this.page_overlay) {
          this.closeCart();
        }
      }

      closeCart() {
        // Fire the quick-buy drawer-close event
        publish(PUB_SUB_EVENTS.quickBuyDrawerClose, { source: "quick-add" });

        const loader = this.quick_add.querySelector(".wt__quick-buy-loader");
        loader.classList.remove("hidden");
        const product = this.quick_add.querySelector(".wt-product");

        if (product) product.remove();

        this.body.classList.remove("quick-buy-page-overlay");
        this.page_overlay.classList.remove("wt__quick-buy--page-overlay--open");
        this.quick_add_container.classList.remove(
          "wt__quick-buy__container--open",
        );
        this.isDrawerOpen = false;
        this.hideViewAllDetailsButton();
        document.removeEventListener("click", this.handleInteractionOutside);
        this.disconnectObserver();
        this.removeButtonEventListener();
      }

      removeElements(element, ...selectors) {
        selectors.forEach((selector) => {
          const elements = element.querySelectorAll(selector);
          elements.forEach((el) => el.remove());
        });
      }

      updateAttribute(element, attribute, value) {
        if (element) {
          element.setAttribute(attribute, value);
        }
      }

      updateFieldSets(fieldSets) {
        fieldSets.forEach((fieldset) => {
          const inputRadios = fieldset.querySelectorAll('input[type="radio"]');
          const labels = fieldset.querySelectorAll("label");

          inputRadios.forEach((radio) => {
            this.updateAttribute(
              radio,
              "id",
              `quick-${radio.getAttribute("id")}`,
            );
            this.updateAttribute(
              radio,
              "form",
              `product-form-${radio.getAttribute("id")}`,
            );
          });

        labels.forEach((label) => {
          const labelFor = label.getAttribute("for");

          if (labelFor) {
            this.updateAttribute(
              label,
              "for",
              `quick-${labelFor}`,
            );
          }
        });
        });
      }

      disconnectObserver() {
        this.observer?.disconnect();
      }

      removeButtonEventListener() {
        if (this.add_button)
          this.add_button.removeEventListener("click", () =>
            this.fetchProduct(this.product_url),
          );
      }

      disconnectedCallback() {
        this.disconnectObserver();
        this.removeButtonEventListener();
      }
    },
  );
}